import { Overlay } from "config/enums/overlays";
import { Routing } from "config/enums/routings";
import { SaveableOptions } from "stores/optionsStore/state";
import { isValidMapID } from "utils/validators/isValidMapID";

export interface UserSettings extends SaveableOptions {
  routing: Routing;
}

/**
 * Parses the user's settings from the server (on sign in and when the app opens signed in). The server doesn't
 * validate them, so map overlays the app doesn't know and an unknown map are left out - the current ones are kept.
 */
export const parseSettingsToObj = (
  settingsString: string | null | undefined
): Partial<UserSettings> | null => {
  if (!settingsString) return null;
  const { mapType, mapOverlays, ...rest } = JSON.parse(
    settingsString
  ) as Partial<UserSettings>;
  const knownOverlays: unknown[] = Object.values(Overlay);

  return {
    ...rest,
    ...(Array.isArray(mapOverlays)
      ? {
          mapOverlays: mapOverlays.filter((overlay) =>
            knownOverlays.includes(overlay)
          ),
        }
      : {}),
    ...(typeof mapType === "number" && isValidMapID(mapType)
      ? { mapType }
      : {}),
  };
};

export const parseSettingsToString = ({
  mapOverlays: overlay,
  viewCenter: viewBounds,
  viewZoom: zoom,
  ...rest
}: Partial<UserSettings>) => {
  const settings: Partial<UserSettings> = {
    viewCenter: viewBounds,
    viewZoom: zoom,
    mapOverlays: overlay,
    ...rest,
  };
  return JSON.stringify(settings);
};
